export const UVPRINT_EXAMPLE_ASSETS = [
  {
    url: 'https://res.cloudinary.com/trendhim/image/upload/f_auto,c_pad,q_auto,w_320/frontend/personalisation/uv-print/watches/uv-image-child-in-watch.jpg',
    tags: ['gallery'],
    caption: 'products:UV_PRINT_CAPTION_CHILD',
  },
  {
    url: 'https://res.cloudinary.com/trendhim/image/upload/f_auto,c_pad,q_auto,w_320/frontend/personalisation/uv-print/watches/uv-image-wedding-in-watch.jpg',
    tags: ['gallery'],
    caption: 'products:UV_PRINT_CAPTION_WEDDING',
  },
  {
    url: 'https://res.cloudinary.com/trendhim/image/upload/f_auto,c_pad,q_auto,w_320/frontend/personalisation/uv-print/watches/uv-image-travel-in-watch.jpg',
    tags: ['gallery'],
    caption: 'products:UV_PRINT_CAPTION_TRAVEL',
  },
  {
    url: 'https://res.cloudinary.com/trendhim/image/upload/f_auto,c_pad,q_auto,w_320/frontend/personalisation/uv-print/watches/uv-image-grandma-in-watch.jpg',
    tags: ['gallery'],
    caption: 'products:UV_PRINT_CAPTION_GRANDMA',
  },
  {
    url: 'https://res.cloudinary.com/trendhim/image/upload/f_auto,c_pad,q_auto,w_320/frontend/personalisation/uv-print/watches/uv-image-father-in-watch.jpg',
    tags: ['gallery'],
    caption: 'products:UV_PRINT_CAPTION_FATHER',
  },
  {
    url: 'https://res.cloudinary.com/trendhim/image/upload/f_auto,c_pad,q_auto,w_320/frontend/personalisation/uv-print/watches/uv-image-dog-in-watch.jpg',
    tags: ['gallery'],
    caption: 'products:UV_PRINT_CAPTION_DOG',
  },
  {
    url: 'https://res.cloudinary.com/trendhim/image/upload/f_auto,c_pad,q_auto,w_320/frontend/personalisation/uv-print/watches/uv-image-car-in-watch.jpg',
    tags: ['gallery'],
    caption: 'products:UV_PRINT_CAPTION_CAR',
  },
]
